import { Component, OnInit } from '@angular/core';
import {EventsService} from "../../../events.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-ramadan2022-home-page',
  templateUrl: './ramadan2022-home-page.component.html',
  styleUrls: ['./ramadan2022-home-page.component.scss']
})
export class Ramadan2022HomePageComponent implements OnInit {
  games;
  tournaments ;
  events
  constructor(public eventService:EventsService ) {

  }


  ngOnInit(): void {

    this.changeRoute()
  }
  changeRoute() {
    this.eventService.loadEventTournaments = true;
    this.eventService.getEventTournaments('ramadan-2022', 1 ).subscribe(res => {
      this.tournaments = res.data.slice(0 , 4)

      this.eventService.loadEventTournaments = false;
    }, error => {
      this.eventService.eventTournaments.next({data: []});
      this.eventService.loadEventTournaments = false;
    })

  }
}
